export enum ClassificationLevel {
	None = 'null',
	Low = 'Low',
	Medium = 'Medium',
	High = 'High',
	Critical = 'Critical'
}
